(() => {
  const index = Array.isArray(window.CKB_SEARCH_INDEX) ? window.CKB_SEARCH_INDEX : [];
  const target = item => /^CKC-KA-15(?:0[0-9])$/.test(item.id || '')
    || /^CKC-LD3-000[1-6]$/.test(item.id || '')
    || /^(?:CKC-KA-1409|CKC-KA-1412|CKC-KA-1417)$/.test(item.id || '');
  const boundedTitle = title => {
    const suffix = ' | Chameleon CKB';
    const available = 70 - suffix.length;
    const clean = String(title || '').trim();
    return `${clean.length > available ? `${clean.slice(0, available - 1).trim()}…` : clean}${suffix}`;
  };
  const boundedDescription = value => {
    const clean = String(value || '').replace(/\s+/g, ' ').trim();
    return clean.length > 160 ? `${clean.slice(0, 159).trim()}…` : clean;
  };

  for (const item of index) {
    if (!target(item)) continue;
    item.canonicalId = item.id;
    item.canonicalHandle = item.handle;
    item.seoTitle = boundedTitle(item.title);
    item.metaDescription = boundedDescription(item.summary || item.quick);
    item.sourceReviewed = item.sourceReviewed || item.reviewed || '2026-08-30';
    item.sourceAuthority = item.sourceAuthority || (/^CKC-LD3-/.test(item.id || '')
      ? 'CHA LD-3 User Guide 260112 and current live product record'
      : 'Current controlled Chameleon product guide and product record');
    item.freshnessPolicy = item.freshnessPolicy || 'Review after a source, product status, compatibility, safety, or documented technical change.';
  }
})();
